import {AreaAnalyticsFilter, BuildingType} from '@/map/enums';

export const HOUSE_MARKER_INFO = {
  [BuildingType.Apartment]: {
    color: '#f07162',
  },
  [AreaAnalyticsFilter.UPCOMMING_APTS]: {
    color: '#9a00e1',
  },
  [BuildingType.Officetel]: {
    color: '#ffaf00',
  },
  [BuildingType.Villa]: {
    color: '#4b9bfa',
  },
  [BuildingType.HOUSE]: {
    color: '#38B777',
  },
};
